import React from 'react'
import styled from 'styled-components'

import { ClockIcon } from '../../components/Icons/Clock'
import { pad2 } from '../../utils/string'

const HOUR_MASK = /(0[0-9]|1[0-9]|2[0-3])/
const MINUTES_MASK = /[0-5][0-9]/

const Wrapper = styled.time`
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
  }
`

const Hour12 = styled.div`
  text-transform: uppercase;
  margin-left: 5px;
`

const getHour12 = (hour) => {
  return hour < 12 ? 'am' : 'pm'
}

const getDisplayedHour = (hour) => {
  hour = parseInt(hour)

  if (hour === 0 || hour === 12) {
    return '12'
  }

  return pad2(hour % 12)
}

export const FormattedTime = ({ time = '', noIcon }) => {
  const [hour, minutes] = time.split(':')

  if (!HOUR_MASK.test(hour) || !MINUTES_MASK.test(minutes)) {
    return '-'
  }

  const displayedHour = getDisplayedHour(hour)

  return (
    <Wrapper>
      {!noIcon && <ClockIcon />}

      <div>
        {displayedHour}:{minutes}
      </div>

      <Hour12>{getHour12(hour)}</Hour12>
    </Wrapper>
  )
}
